import {
  ChangeDetectionStrategy,
  Component,
  ChangeDetectorRef,
  HostListener,
  ViewChildren,
  QueryList,
  inject,
  viewChildren,
  signal,
} from '@angular/core';
import { APIService } from 'src/app/services/APIService/api.service';
import { first } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { SpinnerService } from 'src/app/services/Spinner/spinner.service';
import { ToastService } from 'src/app/services/toast.service';
import { MrTranslatePipe } from 'src/app/pipes/mr-translate.pipe';
import { DndModule } from 'ngx-drag-drop';
import { dbS } from 'src/app/services/_offline/StorageDexie';

import * as Plotly from 'plotly.js-basic-dist-min';

import OlMap from 'ol/Map';
import OlView from 'ol/View';
import OlVectorLayer from 'ol/layer/Vector';
import OlVectorSource from 'ol/source/Vector';
import OlGeoJSON from 'ol/format/GeoJSON';
import OlStyle from 'ol/style/Style';
import OlStroke from 'ol/style/Stroke';
import { defaults } from 'ol/control';
import { fromLonLat } from 'ol/proj';
import { getLength as geoDesLength } from 'ol/sphere';
import { Feature } from 'ol';
import { Point } from 'ol/geom';
import CircleStyle from 'ol/style/Circle';
import Fill from 'ol/style/Fill';
import { TileLayerObj } from 'src/app/content/GISMap/ol-exports';
import { CommonModule } from '@angular/common';
import { ClarityModule } from '@clr/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ExcelService } from 'src/app/services/Shared/excel.service';
import { PlotlyPlotLokalComponent } from './plotly-plot-local';
import JSZip from 'jszip';
import { read, utils, WorkBook } from 'xlsx';
import { AuthService } from 'src/app/services/Auth/auth.service';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-messungsdialog',
  templateUrl: './messungsdialog.component.html',
  styleUrls: ['./messungsdialog.component.scss'],
  imports: [
    CommonModule,
    ClarityModule,
    DndModule,
    MrTranslatePipe,
    FormsModule,
    ReactiveFormsModule,
    PlotlyPlotLokalComponent,
  ],
})
export class MessungsdialogComponent {
  private readonly apiservice = inject(APIService);
  private readonly spinner = inject(SpinnerService);
  private readonly toastr = inject(ToastService);
  private readonly changeDet = inject(ChangeDetectorRef);
  private readonly mrTranslate = inject(MrTranslatePipe);
  private readonly excelService = inject(ExcelService);

  ostammid: number;
  tblPruefids: any;
  selection: any;
  selpruefids: string = '';
  selDates: string[] = [];
  curIndex = 0;
  selIsOpen = false;
  map: OlMap;
  geolayer: any;
  Object = Object;
  placeHolderHeight = 50;
  draganddropactive = false;
  bauwerkeactive = false;
  isDetailViewVisible = false;
  curGraph: any;
  layers: any[] = [];
  positionFeature = new Feature();
  highlightfeature: any;
  darkMap: boolean = false;

  min: number;
  max: number;

  @ViewChildren('plotCmp')
  plotComponents!: QueryList<PlotlyPlotLokalComponent>;

  graph: any = {
    layout: {
      autosize: true,
      hovermode: 'closest',
      showlegend: false,
      legend: { orientation: 'h' },
      height: 250,
      margin: {
        l: 35,
        r: 20,
        b: 25,
        t: 20,
        pad: 0,
      },
      plot_bgcolor: 'transparent',
      paper_bgcolor: 'transparent',
    },
    config: {
      responsive: true,
      displaylogo: false,
      locale: 'de',
      modeBarButtonsToRemove: [
        'sendDataToCloud',
        'lasso2d',
        'autoScale2d',
        'toggleSpikelines',
        'hoverCompareCartesian',
        'hoverClosestCartesian',
      ],
    },
    m: [],
    show: {},
    y: [],
    layouts: {
      Radius: {
        autosize: true,
        hovermode: 'closest',
        showlegend: false,
        legend: { orientation: 'h' },
        height: 250,
        margin: {
          l: 35,
          r: 20,
          b: 25,
          t: 20,
          pad: 0,
        },
        plot_bgcolor: 'transparent',
        paper_bgcolor: 'transparent',
        yaxis: {
          range: [-10000, 10000],
        },
      },
    },
    data: [
      {
        name: 'Spur',
        key: 'Spur',
        yData: [],
      },
      {
        name: 'Bogen',
        key: 'Bogen',
        yData: [],
      },
      {
        name: 'Überhöhung',
        key: 'Ueberhoehung',
        yData: [],
      },
      {
        name: 'Längshöhe',
        key: 'Tiefpunkt',
        yData: [],
      },
      {
        name: 'Verwindung',
        key: 'Verwindung1',
        yData: [],
      },
      {
        name: 'Verwindung2',
        key: 'Verwindung2',
        yData: [],
      },
      {
        name: 'Rillen',
        key: 'Rille',
        yData: null,
      },
      {
        name: 'Rille links',
        key: 'Rille_L',
        yData: [],
      },
      {
        name: 'Rille rechts',
        key: 'Rille_R',
        yData: [],
      },
      {
        name: '∆H links',
        key: 'DH_L',
        yData: [],
      },
      {
        name: '∆S1 links',
        key: 'DS1_L',
        yData: [],
      },
      {
        name: '∆S2 links',
        key: 'DS2_L',
        yData: [],
      },
      {
        name: '∆H rechts',
        key: 'DH_R',
        yData: [],
      },
      {
        name: '∆S1 rechts',
        key: 'DS1_R',
        yData: [],
      },
      {
        name: '∆S2 rechts',
        key: 'DS2_R',
        yData: [],
      },
      {
        name: 'Fahrdraht-Höhe',
        key: 'FahrdrahtX',
        yData: [],
      },
      {
        name: 'Fahrdraht-Zickzack',
        key: 'FahrdrahtY',
        yData: [],
      },
    ],
  };

  tileLayers = TileLayerObj;

  minTol_Sp: number = -10000;
  maxTol_SP: number = 10000;
  minTol_Lim: number = -10000;
  maxTol_Lim: number = 10000;
  minTol_100: number = -10000;
  maxTol_100: number = 10000;
  curMessung: any = [];
  orgMessung: any = [];

  verletzung: any = [];
  showverletzung: boolean = false;
  showmesswerte: boolean = false;
  objektname: string = '';
  signpostOpened = false;
  authService = inject(AuthService);
  trial: boolean = false;

  public closedialog: BehaviorSubject<boolean> = new BehaviorSubject(false);

  set data(dataIn: any) {
    this.ostammid = dataIn.id;
    this.objektname = dataIn.name;
    this.apiservice
      .getPruefid(this.ostammid, 'ogmess')
      .pipe(first())
      .subscribe((res: any) => {
        this.tblPruefids = res;
        if (res.rows.length == 0) {
          this.spinner.disable();
          this.toastr.warning(this.mrTranslate.transform('Keine Daten vorhanden'));
          this.close();
          return;
        }
        this.selpruefids = '-1';
        this.selDates.push('');
        this.getMessungen(this.ostammid);
        if (res.rows.length > 0) {
          this.selection = [res.rows[res.rows.length - 1]];
        }
      });
  }
  selOpenChanged(event: any) {
    this.selIsOpen = event;
    if (event) return;
    this.selpruefids = '';
    this.graph.m = [];
    this.graph.show = {};
    this.graph.y = [];
    this.selDates = [];
    this.graph.data.forEach(element => {
      element.yData = [];
    });
    this.spinner.enable();
    if (!this.selection || this.selection.length == 0) {
      this.selpruefids = '-1';
      this.selDates.push('');
    } else {
      this.selection.forEach(element => {
        this.selpruefids += element.id + ',';
        this.selDates.push(element.Datum);
      });
      this.selpruefids = this.selpruefids.slice(0, -1);
    }

    this.getMessungen(this.ostammid);
  }

  selChanged(event: any) {
    if (this.selIsOpen || !event.model) return;
    this.selpruefids = '';
    this.graph.m = [];
    this.graph.show = {};
    this.graph.y = [];
    this.selDates = [];
    this.graph.data.forEach(element => {
      element.yData = [];
    });
    this.spinner.enable();
    if (!this.selection || this.selection.length == 0) {
      this.selpruefids = '-1';
      this.selDates.push('');
    } else {
      event.model.forEach(element => {
        this.selpruefids += element.id + ',';
        this.selDates.push(element.Datum);
      });
      this.selpruefids = this.selpruefids.slice(0, -1);
    }

    this.getMessungen(this.ostammid);
  }

  getMessungen(stammid: number) {
    this.apiservice
      .getMessungen(this.selpruefids, stammid)
      .pipe(first())
      .subscribe((res: any) => {
        if (res.error) {
        }

        var jsZip = typeof (<any>JSZip).default === 'function' ? new (<any>JSZip).default() : new JSZip();
        jsZip
          .loadAsync(res)
          .then(zip => {
            return zip.file('tmp.txt').async('string');
          })
          .then(async zipf => {
            let results = JSON.parse(zipf);
            let settings = results.settings;
            let measurements = results.measurements;
            if (!measurements || (measurements.length == 1 && measurements[0].length == 0)) {
              this.spinner.disable();
              this.toastr.warning(this.mrTranslate.transform('Keine Daten vorhanden'));
              this.close();
              return;
            }

            this.minTol_Sp = Math.min(...measurements[0].SRG_M);
            this.maxTol_SP = Math.max(...measurements[0].SRG_P);
            this.curMessung = measurements[0];
            this.orgMessung = structuredClone(measurements[0]);

            this.min = Math.min(...measurements[0].m);
            this.max = Math.max(...measurements[0].m);

            for (this.curIndex = 0; this.curIndex < measurements.length; this.curIndex++) {
              const measurement = measurements[this.curIndex];

              Object.keys(measurement).forEach((valName: any) => {
                let showName = valName;
                if (valName == 'm') return;

                showName = valName;
                if (valName.includes('SR')) showName = 'Spur';
                if (valName == 'SollSpur') showName = 'Spur';

                if (valName == 'TolVer_M') showName = 'Verwindung';
                if (valName == 'TolVer_P') showName = 'Verwindung';
                if (valName == 'FahrdrahtX') showName = 'Fahrdraht-Höhe';
                if (valName == 'FahrdrahtY') showName = 'Fahrdraht-Zickzack';

                let ind = this.getGraphIndex(showName);

                if (ind != undefined) {
                  let correctName = valName.replace('_M', '-').replace('_P', '+');
                  let searchAddition = valName.includes('SR') ? '' : ' ' + this.selDates[this.curIndex];
                  let found = false;
                  for (const yData of this.graph.data[ind].yData) {
                    if (yData.name == correctName + searchAddition) {
                      found = true;
                      yData.x.push(new Float32Array(measurement['m']));
                      yData.y.push(new Float32Array(measurement[valName]));
                      break;
                    }
                  }
                  if (!found) {
                    let newPlot: Plotly.Data = {
                      name: correctName + searchAddition,
                      visible: valName.includes(valName) ? true : 'legendonly',
                      type: 'scattergl',
                      marker: {
                        size: Number.MIN_VALUE,
                      },
                      x: new Float32Array(measurement['m']),
                      y: new Float32Array(measurement[valName]),
                    };
                    this.graph.data[ind].yData.push(newPlot);
                  }
                }

                if (showName != 'm' && ind !== undefined) {
                  if (!showName.toLowerCase().includes('ds') && !showName.toLowerCase().includes('dh')) {
                    this.graph.data[ind].show = true;
                  }
                  if (
                    showName.toLowerCase().includes('fahrdraht') &&
                    this.graph.data[ind].yData[0].name.toLowerCase().includes('fahrdraht')
                  ) {
                    this.graph.data[ind].show = true;
                  }

                  if (
                    !this.graph.data[ind].layout &&
                    settings[showName]!.ymax !== undefined &&
                    settings[showName]!.ymax !== undefined
                  ) {
                    let layout = structuredClone(this.graph.layout);
                    layout.showlegend = true;
                    layout.yaxis = {
                      range: [settings[showName].ymin, settings[showName].ymax],
                    };
                    this.graph.data[ind].layout = layout;
                  }
                }
              });
            }

            this.graph.data[7].show = false;
            this.graph.data[8].show = false;
            let z: number = 0;

            this.graph.data.forEach(element => {
              if (element.name == 'Verwindung') {
                element.yData.forEach(i => {
                  if (i.name.startsWith('Verwindung1')) {
                    i.name = i.name.replace('Verwindung1', 'Verwindung');
                    if (z == 0) {
                      i.line = { color: 'rgb(53, 132, 187)' };
                    }
                    z++;
                  }
                  if (i.name.includes('TolVer-')) {
                    i.name = 'SRG -';
                    i.line = { color: 'rgb(247, 0, 0)' };
                  }
                  if (i.name.includes('TolVer+')) {
                    i.name = 'SRG +';
                    i.line = { color: 'rgb(247, 0, 0)' };
                  }
                });
              }

              if (
                element.name == 'Verwindung' ||
                element.name == 'Überhöhung' ||
                element.name == 'Längshöhe' ||
                element.name == 'Bogen'
              ) {
                if (element.yData.length > 0) {
                  let zeroLine: Plotly.Data = {
                    name: '0-Line',
                    type: 'scattergl',
                    mode: 'lines',
                    showlegend: false,
                    hoverinfo: 'skip',
                    line: {
                      color: 'rgb(60, 60, 60)',
                      width: 1,
                    },
                    x: new Float32Array(measurements[0]['m']),
                    y: new Float32Array(measurements[0]['m'].length).fill(0),
                  };

                  element.yData.unshift(zeroLine);
                }
              }
            });

            let sp = structuredClone(this.graph.data[0].yData);
            z = 0;
            sp.forEach(element => {
              if (element.name.includes('SollSpur')) {
                element.name = 'Soll';
                element.line = { color: 'rgb(0, 0, 0)' };
              }
              if (element.name.includes('SRG')) {
                element.line = { color: 'rgb(247, 0, 0)' };
              }
              if (element.name.includes('SRlim')) {
                element.line = { color: 'rgb(247, 247, 0)', dash: 'dashdot' };
              }
              if (element.name.includes('SR100')) {
                element.line = { color: 'rgb(0, 247, 74)', dash: 'dot' };
              }
              if (element.name?.startsWith('Spur')) {
                //element.name = 'Spur';
                if (z == 0) {
                  element.line = { color: 'rgb(53, 132, 187)' };
                }
                z++;
              }
            });

            let sp_new = [];
            let soll = sp.filter(x => x.name.includes('Soll'));
            soll.forEach(element => {
              sp_new.push(element);
            });
            let sr1 = sp.filter(x => x.name.includes('SR100'));
            sr1.forEach(element => {
              sp_new.push(element);
            });
            let srl = sp.filter(x => x.name.includes('SRlim'));
            srl.forEach(element => {
              sp_new.push(element);
            });
            let srg = sp.filter(x => x.name.includes('SRG'));
            srg.forEach(element => {
              sp_new.push(element);
            });
            let spur = sp.filter(x => x.name.includes('Spur'));
            spur.forEach(element => {
              sp_new.push(element);
            });
            this.graph.data[0].yData = sp_new;

            this.spinner.disable();
          });
      });
  }

  getMessungen_old(stammid: number) {
    this.apiservice
      .getMessungen(this.selpruefids, stammid)
      .pipe(first())
      .subscribe((res: any) => {
        if (res.error) {
          this.toastr.warning(this.mrTranslate.transform('Keine Daten vorhanden'));
          return;
        }
        let settings = res.settings;
        let measurements = res.measurements;
        if (!measurements || (measurements.length == 1 && measurements[0].length == 0)) {
          this.spinner.disable();
          this.toastr.warning(this.mrTranslate.transform('Keine Daten vorhanden'));
          this.close();
          return;
        }

        this.minTol_Sp = Math.min(...measurements[0].map(item => item.SRG_M));
        this.maxTol_SP = Math.max(...measurements[0].map(item => item.SRG_P));
        this.minTol_Lim = Math.min(...measurements[0].map(item => item.SRlim_M));
        this.maxTol_Lim = Math.max(...measurements[0].map(item => item.SRlim_P));
        this.minTol_100 = Math.min(...measurements[0].map(item => item.SR100_M));
        this.maxTol_100 = Math.max(...measurements[0].map(item => item.SR100_P));
        this.curMessung = measurements[0];

        this.min = measurements[0][0]['m'];
        this.max = measurements[0][measurements[0].length - 1]['m'];
        for (this.curIndex = 0; this.curIndex < measurements.length; this.curIndex++) {
          const measurement = measurements[this.curIndex];

          measurement.forEach(val => {
            Object.keys(val).forEach((valName: any) => {
              let showName = valName;
              let ind = this.getGraphIndex(valName);
              if (val[valName] != null && val[valName] != 0) {
                if (valName == 'm') return;

                showName = valName;
                if (valName.includes('SR')) showName = 'Spur';
                if (valName == 'SollSpur') showName = 'Spur';

                if (valName == 'TolVer_M') showName = 'Verwindung';
                if (valName == 'TolVer_P') showName = 'Verwindung';

                ind = this.getGraphIndex(showName);
                if (ind != undefined) {
                  let correctName = valName.replace('_M', '-').replace('_P', '+');
                  let searchAddition = valName.includes('SR') ? '' : ' ' + this.selDates[this.curIndex];
                  let found = false;
                  for (const yData of this.graph.data[ind].yData) {
                    if (yData.name == correctName + searchAddition) {
                      found = true;
                      yData.x.push(val['m']);
                      yData.y.push(val[valName]);
                      break;
                    }
                  }
                  if (!found) {
                    let newPlot: Plotly.Data = {
                      name: correctName + searchAddition,
                      visible: valName.includes(valName) ? true : 'legendonly',
                      type: 'scattergl',
                      marker: {
                        size: Number.MIN_VALUE,
                      },
                      x: [val['m']],
                      y: [val[valName]],
                    };
                    this.graph.data[ind].yData.push(newPlot);
                  }
                }
              }

              if (showName != 'm' && ind !== undefined) {
                if (!showName.toLowerCase().includes('ds') && !showName.toLowerCase().includes('dh')) {
                  this.graph.data[ind].show = true;
                }

                if (
                  !this.graph.data[ind].layout &&
                  settings[showName].ymin !== undefined &&
                  settings[showName].ymax !== undefined
                ) {
                  let layout = structuredClone(this.graph.layout);
                  layout.showlegend = true;
                  layout.yaxis = {
                    range: [settings[showName].ymin, settings[showName].ymax],
                  };
                  this.graph.data[ind].layout = layout;
                }
              }
            });
          });
        }

        this.graph.data[7].show = false;
        this.graph.data[8].show = false;

        this.graph.data.forEach(element => {
          if (element.name == 'Verwindung') {
            element.yData.forEach(i => {
              if (i.name == 'Verwindung1 ') {
                i.name = 'Verwindung';
                i.line = { color: 'rgb(53, 132, 187)' };
              }
              if (i.name == 'TolVer- ') {
                i.name = 'SRG -';
                i.line = { color: 'rgb(247, 0, 0)' };
              }
              if (i.name == 'TolVer+ ') {
                i.name = 'SRG +';
                i.line = { color: 'rgb(247, 0, 0)' };
              }
            });
          }
          //Nulllinien hinzufügen, verdeckt aber die eigentlichen Werte zu viel
          if (element.name == 'Verwindung' || element.name == 'Überhöhung' || element.name == 'Bogen') {
            element.yData.push(structuredClone(this.graph.data[0].yData[0]));
            let x = element.yData.slice(-1)[0];
            x.name = 'Nulllinie';
            x.marker.size = 0.5;
            x.marker.color = '#b9b9b9';
            x['y'] = x['y'].map(i => (i = 0));
            element.yData = element.yData.reverse();
          }
        });

        let sp = structuredClone(this.graph.data[0].yData);

        sp.forEach(element => {
          if (element.name == 'SollSpur ') {
            element.name = 'Soll';
            element.line = { color: 'rgb(0, 0, 0)' };
          }
          if (element.name.includes('SRG')) {
            element.line = { color: 'rgb(247, 0, 0)' };
          }
          if (element.name.includes('SRlim')) {
            element.line = { color: 'rgb(247, 247, 0)', dash: 'dashdot' };
          }
          if (element.name.includes('SR100')) {
            element.line = { color: 'rgb(0, 247, 74)', dash: 'dot' };
          }
          if (element.name == 'Spur ') {
            element.name = 'Spur';
            element.line = { color: 'rgb(53, 132, 187)' };
          }
        });

        let sp_new = [];
        let soll = sp.filter(x => x.name.includes('Soll'));
        soll.forEach(element => {
          sp_new.push(element);
        });
        let sr1 = sp.filter(x => x.name.includes('SR100'));
        sr1.forEach(element => {
          sp_new.push(element);
        });
        let srl = sp.filter(x => x.name.includes('SRlim'));
        srl.forEach(element => {
          sp_new.push(element);
        });
        let srg = sp.filter(x => x.name.includes('SRG'));
        srg.forEach(element => {
          sp_new.push(element);
        });
        let spur = sp.filter(x => x.name.includes('Spur'));
        spur.forEach(element => {
          sp_new.push(element);
        });
        this.graph.data[0].yData = sp_new;

        this.spinner.disable();
      });
  }

  set combineRille(newVal: boolean) {
    let indRille = this.getGraphIndex('Rille');
    let indRille_L = this.getGraphIndex('Rille_L');
    let indRille_R = this.getGraphIndex('Rille_R');
    if (newVal) {
      let leftrille = this.graph.data[indRille_L].yData[0];
      leftrille.line = { color: 'rgb(0, 247, 74)' };
      this.graph.data[indRille].yData = [leftrille, this.graph.data[indRille_R].yData[0]];
      this.graph.data[indRille].show = true;
      this.graph.data[indRille_L].yData = null;
      this.graph.data[indRille_R].yData = null;
    } else {
      let leftrille = this.graph.data[indRille].yData[0];
      leftrille.line.color = 'rgb(53, 132, 187)';
      this.graph.data[indRille_L].yData = [leftrille];
      this.graph.data[indRille_R].yData = [this.graph.data[indRille].yData[1]];
      this.graph.data[indRille_L].show = true;
      this.graph.data[indRille_R].show = true;
      this.graph.data[indRille].yData = null;
    }
    if (!this.graph.data[indRille].layout) {
      let layout = structuredClone(this.graph.data[indRille_L].layout);
      layout.showlegend = true;
      this.graph.data[indRille].layout = layout;
    }
    this._combineRille = newVal;
  }

  get combineRille() {
    return this._combineRille;
  }

  _combineRille: boolean = false;

  dndsettings = (str: string) => {
    return {
      content: str,
      effectAllowed: 'move',
      disable: false,
      handle: false,
    };
  };

  constructor() {
    this.graph.m = [];
    this.graph.y = [];
  }

  lastData: any;

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (this.lastData != undefined) {
      if (event.key == 'ArrowLeft' && this.lastData.points[0].x > this.min + 1) {
        this.lastData.points[0].x -= 1;
      }

      if (event.key == 'ArrowRight' && this.lastData.points[0].x < this.max - 1) {
        this.lastData.points[0].x += 1;
      }

      let dataPoint = {
        mode: 'line',
        name: 'Selektierte Position',
        type: 'lines',
        x: [this.lastData.points[0].x, this.lastData.points[0].x],
        y: [this.curGraph.layout.yaxis.range[0], this.curGraph.layout.yaxis.range[1]],
        visible: true,
      };
      if (this.curGraph.yData[this.curGraph.yData.length - 1].name == 'Selektierte Position') {
        this.curGraph.yData[this.curGraph.yData.length - 1] = dataPoint;
      } else {
        this.curGraph.yData.push(dataPoint);
      }

      Plotly.react('plotly_Sub', this.curGraph.yData, this.curGraph.layout);

      if (this.max > this.min) {
        this.getFeatPos((this.lastData.points[0].x - this.min).toString());
      } else {
        this.getFeatPos((this.lastData.points[0].x - this.max).toString());
      }
    }
  }

  shrink(graphData: any) {
    // Reset all cards
    this.graph.data = this.graph.data.map(d => ({
      ...d,
      fullsize: false,
      layout: { ...d.layout, height: 250 }, // reset height
    }));

    // Wait for Angular to apply DOM changes
    setTimeout(() => {
      const cmp = this.plotComponents.find(p => p.id() === graphData.key);
      cmp?.resizePlot();
    }, 100); // 100ms is safer
  }

  resize(graphData: any) {
    // Reset all cards
    this.graph.data = this.graph.data.map(d => ({
      ...d,
      fullsize: false,
      layout: { ...d.layout, height: 250 }, // reset height
    }));

    // Expand selected card
    const ind = this.getGraphIndex(graphData.key);
    const card = this.graph.data[ind];
    this.graph.data[ind] = {
      ...card,
      fullsize: true,
      layout: { ...card.layout, height: 620 }, // set height immutably
    };

    // Wait for Angular to apply DOM changes
    setTimeout(() => {
      const cmp = this.plotComponents.find(p => p.id() === graphData.key);
      cmp?.resizePlot();
    }, 100); // 100ms is safer
  }

  loadDetailView(graphData: any) {
    this.curGraph = structuredClone(graphData); //Deep Copy
    this.isDetailViewVisible = true;

    this.apiservice
      .getMessungGeo(this.ostammid)
      .pipe()
      .subscribe((res: any) => {
        setTimeout(() => {
          this.loadMap(res);
          this.curGraph.layout.height = 350;
          Plotly.newPlot('plotly_Sub', this.curGraph.yData, this.curGraph.layout);
          let myPlot: any = document.getElementById('plotly_Sub');
          myPlot.on('plotly_click', data => {
            this.lastData = data;
            let dataPoint = {
              mode: 'line',
              name: 'Selektierte Position',
              type: 'lines',
              x: [data.points[0].x, data.points[0].x],
              y: [this.curGraph.layout.yaxis.range[0], this.curGraph.layout.yaxis.range[1]],
              visible: true,
            };
            if (this.curGraph.yData[this.curGraph.yData.length - 1].name == 'Selektierte Position') {
              this.curGraph.yData[this.curGraph.yData.length - 1] = dataPoint;
            } else {
              this.curGraph.yData.push(dataPoint);
            }

            Plotly.react('plotly_Sub', this.curGraph.yData, this.curGraph.layout);

            if (this.max > this.min) {
              this.getFeatPos((data.points[0].x - this.min).toString());
            } else {
              this.getFeatPos((data.points[0].x - this.max).toString());
            }
          });
        });
      });
  }

  getGraphIndex(key: string): number {
    for (let i = 0; i < this.graph.data.length; i++) {
      if (this.graph.data[i].key.toLowerCase().includes(key.toLowerCase())) {
        return i;
      }
    }
    return undefined;
  }

  onMessungYSpiegeln(pruefid: any, typ: string) {
    console.log(pruefid);

    this.spinner.enable();

    this.graph.data.forEach(element => {
      element.yData = [];
    });

    this.apiservice
      .setMessungenMirrow(pruefid.id, { typ })
      .pipe(first())
      .subscribe((res: any) => {
        if (res.sucess) {
          this.getMessungen(this.ostammid);
        } else {
          this.spinner.disable();
          this.toastr.error(this.mrTranslate.transform(res.error));
        }
      });
  }

  applyYaxis(name: string) {
    let ind = this.getGraphIndex(name);
    this.graph.data[ind].show = false;
    this.changeDet.detectChanges();
    this.graph.data[ind].show = true;
  }

  onDrop(event) {
    let oldIndex = this.getGraphIndex(event.data.key);
    let newIndex = event.index;
    if (oldIndex != newIndex) {
      let save = structuredClone(this.graph.data[newIndex]);
      this.graph.data[newIndex] = structuredClone(this.graph.data[oldIndex]);
      this.graph.data[oldIndex] = save;
    }
    this.changeDet.detectChanges();
  }

  onDragStart(event) {
    this.placeHolderHeight = event.srcElement.clientHeight;
  }

  public close() {
    this.graph.m = [];
    this.graph.y = [];
    this.closedialog.next(true);
  }

  getMesswerte() {
    this.showmesswerte = !this.showmesswerte;
  }

  // --- EDIT STATE ---
  editingCell: { rowIndex: number; colName: string } | null = null;
  // --- EDIT LOGIC ---
  startEdit(rowIndex: number, colName: string): void {
    this.editingCell = { rowIndex, colName };
  }

  stopEdit(): void {
    let changes = this.getChanges();

    if (changes.length > 0) {
      this.doOffset(this.editingCell.colName, 0);
      this.isChanged = true;
    }

    this.editingCell = null;
  }

  isExcelExportEnabled: boolean = false;
  exportOptions = [
    { label: this.mrTranslate.transform('Bogen'), value: 'Bogen' },
    { label: this.mrTranslate.transform('Spur'), value: 'Spur' },
    { label: this.mrTranslate.transform('Überhöhung'), value: 'Überhöhung' },
    { label: this.mrTranslate.transform('Längshöhe'), value: 'Tiefpunkt' },
    { label: this.mrTranslate.transform('Verwindung'), value: 'Verwindung1' },
  ];
  selectedValue = 'Spur';
  myNumber: number = 0;
  isChanged: boolean = false;

  tableToCurMessung(table: any[]) {
    const result: any = {};

    if (!table.length) {
      return result;
    }

    const columnMap: Record<string, string> = {
      M: 'm',
      BOGEN: 'Bogen',
      RADIUS: 'Radius',
      SPUR: 'Spur',
      UEBERHOEHUNG: 'Ueberhoehung',
      TIEFPUNKT: 'Tiefpunkt',
      VERWINDUNG1: 'Verwindung1',
      RILLE_L: 'Rille_L',
      RILLE_R: 'Rille_R',
    };

    Object.keys(table[0]).forEach(col => {
      const key = columnMap[col.toUpperCase()] ?? col;
      result[key] = table.map(row => row[col]);
    });

    return result;
  }

  getChanges(): any[] {
    const changes: any[] = [];

    const columns = Object.keys(this.curMessung).filter(col => col !== 'm');

    for (let i = 0; i < this.curMessung.m.length; i++) {
      const row: any = {
        m: this.curMessung.m[i],
      };

      let changed = false;

      for (const col of columns) {
        const oldValue = Number(this.orgMessung[col][i]);
        const newValue = Number(this.curMessung[col][i]);

        if (oldValue !== newValue) {
          row[col] = {
            Value: newValue,
          };
          changed = true;
        }
      }

      if (changed) {
        changes.push(row);
      }
    }

    return changes;
  }

  saveChanges() {
    let changes = this.getChanges();

    if (changes.length === 0) {
      this.toastr.info(this.mrTranslate.transform('Keine Änderungen zum Speichern'));
      return;
    }

    this.apiservice
      .setUpdateMessungen(this.tblPruefids.rows[this.tblPruefids.rows.length - 1].id, changes)
      .pipe(first())
      .subscribe((res: any) => {
        if (res.sucess) {
          this.isChanged = false;
          this.orgMessung = structuredClone(this.curMessung);
          this.toastr.success(this.mrTranslate.transform('Änderungen erfolgreich gespeichert'));
        } else {
          this.spinner.disable();
          this.toastr.error(this.mrTranslate.transform(res.error));
        }
      });
  }

  onOffset() {
    const column = this.selectedValue;

    if (!this.curMessung[column]) {
      return;
    }
    this.doOffset(column, this.myNumber);
  }

  doOffset(column, valueOffset: number) {
    if (column === 'Bogen') {
      // Bogen ändern
      this.curMessung['Bogen'] = this.curMessung['Bogen'].map(value => parseFloat((value + valueOffset).toFixed(2)));

      // Radius aus dem neuen Bogen berechnen
      if (this.curMessung['Radius']) {
        this.curMessung['Radius'] = this.curMessung['Bogen'].map(value =>
          parseFloat(((2500 * 2500) / (2 * Number(value)) / 1000).toFixed(2))
        );
      }
    } else {
      this.curMessung[column] = this.curMessung[column].map(value => parseFloat(value + valueOffset));
    }

    // Update the Plotly trace
    const ind = this.getGraphIndex(column);

    if (ind !== undefined) {
      const yData = [...this.graph.data[ind].yData];
      const search = column.replace('1', '');
      const traceIndex = yData.findIndex(trace => trace.name.trimEnd().startsWith(search));

      if (traceIndex !== -1) {
        yData[traceIndex] = {
          ...yData[traceIndex],
          y: Float32Array.from(this.curMessung[column]),
        };

        this.graph.data[ind] = {
          ...this.graph.data[ind],
          yData,
        };

        this.graph.data = [...this.graph.data];
      }
    }
    this.isChanged = true;
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (!input.files?.length) {
      return;
    }

    const file = input.files[0];
    const reader = new FileReader();

    reader.onload = (e: any) => {
      const workbook: WorkBook = read(e.target.result, { type: 'binary' });
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const table = utils.sheet_to_json<any>(sheet);

      this.curMessung = this.tableToCurMessung(table);

      Object.keys(this.curMessung).forEach(key => {
        const ind = this.getGraphIndex(key);

        if (ind === undefined) {
          return;
        }

        const gr = this.graph.data[ind];

        this.graph.data[ind] = {
          ...gr,
          yData: gr.yData.map(trace =>
            trace.name === key ?
              {
                ...trace,
                y: Float32Array.from(this.curMessung[key]),
              }
            : trace
          ),
        };
      });

      // IMPORTANT
      this.graph.data = [...this.graph.data];

      input.value = '';

      this.isChanged = true;
    };

    reader.readAsBinaryString(file);
  }

  doExcelExport() {
    const columns = [
      'm',
      'Bogen',
      'Radius',
      'Spur',
      'Ueberhoehung',
      'Tiefpunkt',
      'Verwindung1',
      'Rille_L',
      'Rille_R',
    ].filter(col => Array.isArray(this.curMessung[col]));

    const table = this.curMessung.m.map((_, i) => {
      const row: any = {};

      columns.forEach(col => {
        row[col] = this.curMessung[col]?.[i];
      });

      return row;
    });

    this.excelService.exportAsExcelFile(table, this.mrTranslate.transform('Messwerte') + '-' + this.objektname);
    this.isExcelExportEnabled = true;
  }

  getGrenzwertverletzung() {
    this.verletzung = [];
    this.berechneGWV('minTol_Sp', 'maxTol_SP', 'SRG ');
    this.berechneGWV('minTol_Lim', 'maxTol_Lim', 'SRlim ');
    this.berechneGWV('minTol_100', 'maxTol_100', 'SR 100 ');
  }

  berechneGWV(feldmin: string, feldmax: string, type: string) {
    const result: { m: number; Spur: number }[] = [];

    // Alle Grenzwertverletzungen sammeln
    for (let i = 0; i < this.curMessung.Spur.length; i++) {
      if (this.curMessung.Spur[i] < this[feldmin] || this.curMessung.Spur[i] > this[feldmax]) {
        result.push({
          m: this.curMessung.m[i],
          Spur: this.curMessung.Spur[i],
        });
      }
    }

    if (result.length === 0) {
      //this.toastr.info(this.mrTranslate.transform('Es wurden keine Grenzwertverletzungen gefunden.'));
      return;
    }

    // Messschritt bestimmen
    const stepMess = this.curMessung.m.length > 1 ? Math.abs(this.curMessung.m[1] - this.curMessung.m[0]) : 0;

    let sP = result[0].m;
    let eP = result[0].m;
    let a = result[0].Spur < this[feldmin] ? '-' : '+';

    const pushVerl = () => {
      if (!this.verletzung.some(x => x.Startposition === sP && x.Endposition === eP && x.Ausfall === type + ' ' + a)) {
        this.verletzung.push({
          Startposition: sP,
          Endposition: eP,
          Ausfall: type + ' ' + a,
          MinMax: this.getMinMax(sP, eP, a),
        });
      }
    };

    // Verletzungen zusammenfassen
    for (let i = 1; i < result.length; i++) {
      const element = result[i];
      const richtung = element.Spur < this[feldmin] ? '-' : '+';

      if (richtung !== a || element.m - eP > stepMess + 1e-6) {
        pushVerl();

        sP = element.m;
        eP = element.m;
        a = richtung;
      } else {
        eP = element.m;
      }
    }

    // Letzte Verletzung speichern
    pushVerl();

    if (this.verletzung.length > 0) {
      this.showverletzung = true;
    } else {
      this.toastr.info(this.mrTranslate.transform('Es wurden keine Grenzwertverletzungen gefunden.'));
    }
  }

  getMinMax(start: number, end: number, a: string): number | null {
    let value: number | null = null;

    for (let i = 0; i < this.curMessung.m.length; i++) {
      if (this.curMessung.m[i] >= start && this.curMessung.m[i] <= end) {
        const spur = this.curMessung.Spur[i];

        if (value === null) {
          value = spur;
        } else if (a === '+' && spur > value) {
          value = spur;
        } else if (a === '-' && spur < value) {
          value = spur;
        }
      }
    }

    return value;
  }

  replaceUnderscore(str: string) {
    return str.replace('_', ' ');
  }

  tileSwitch(tileLayerCat: string, tileLayerKey: string) {
    Object.keys(this.tileLayers).forEach(catname => {
      Object.keys(this.tileLayers[catname]).forEach(layername => {
        this.tileLayers[catname][layername].setVisible(false);
      });
    });
    this.tileLayers[tileLayerCat][tileLayerKey].setVisible(true);
    this.darkMap = !!(tileLayerKey == 'cartoDbDark' || tileLayerKey == 'cartoDbDarkNoLabels');
    const newStyle = this.getLayerStyles();
    this.geolayer.setStyle(newStyle);
  }

  loadMap(res: any) {
    if (res && !this.geolayer) {
      this.layers = [];
      Object.keys(this.tileLayers).forEach(catname => {
        Object.keys(this.tileLayers[catname]).forEach(layername => {
          this.tileLayers[catname][layername].setVisible(false);
          this.layers.push(this.tileLayers[catname][layername]);
        });
      });
      let karte = JSON.parse(localStorage.getItem('karte'));
      this.tileLayers[karte.p][karte.m].setVisible(true);
      this.geolayer = new OlVectorLayer({
        source: new OlVectorSource({
          format: new OlGeoJSON(),
          loader: (extent, resolution, projection) => {
            dbS.getGIS(localStorage.getItem('DB') + localStorage.getItem('karteFileID')).then(x => {
              if (x?.features?.length > 0) {
                //Lade per GIS-IndexedDB
                let src = this.geolayer.getSource();
                setTimeout(() => {
                  let features = src.getFormat().readFeatures(x, {
                    featureProjection: 'EPSG:3857',
                  });
                  src.addFeatures(features);

                  let featurewrap: any = {
                    type: 'Feature',
                    geometry: res,
                  };
                  this.highlightfeature = this.geolayer.getSource().getFormat().readFeature(featurewrap, {
                    featureProjection: 'EPSG:3857',
                  });
                  this.geolayer.getSource().addFeature(this.highlightfeature);
                  this.geolayer.getSource().addFeature(this.positionFeature);
                  setTimeout(
                    () =>
                      this.map
                        .getView()
                        .fit(this.highlightfeature.getGeometry().getExtent(), { duration: 100, maxZoom: 19 }),
                    1000
                  );
                });
              }
            });
          },
        }),
        style: this.getLayerStyles(),
      });
      this.layers.push(this.geolayer);
    }
    if (!this.map) {
      this.map = new OlMap({
        target: 'previewMap',
        layers: this.layers,
        view: new OlView({
          center: fromLonLat([6.747443, 49.981018]),
          maxZoom: 23,
          zoom: 15,
        }),
        controls: defaults({ attribution: false, rotate: false, zoom: false }),
      });
    }

    if (res) {
      this.geolayer.getSource().on('change', () => {
        if (!this.positionFeature.getGeometry()) {
          this.map.getView().fit(this.geolayer.getSource().getExtent(), {
            duration: 100,
            maxZoom: 21,
          });
        } else {
          this.map.getView().fit(this.positionFeature.getGeometry().getExtent(), {
            duration: 100,
            maxZoom: 19,
          });
        }
      });
    }
  }

  toggleBauwerke(event) {
    let firstlbl: boolean = false;
    if (event) {
      let bauwData = {
        name: 'Bauwerke',
        key: 'Bauwerke',
        show: true,
        yData: [],
      };
      let layout: Plotly.Layout = structuredClone(this.graph.layout);
      layout.showlegend = true;
      layout.yaxis = { range: [0, 20] };
      layout.xaxis = {
        range: [this.graph.data[0].layout.xaxis.range[0], this.graph.data[0].layout.xaxis.range[1]],
      };
      layout.height = 120;
      layout.yaxis.visible = false;
      layout.showlegend = true;

      this.graph.data.splice(0, 0, bauwData);
      this.graph.data[0].layout = layout;
      this.apiservice
        .getMessungBauwerke(this.ostammid)
        .pipe(first())
        .subscribe((res: any) => {
          let cntRnge = 0;
          res.bwSoll.rows.forEach(row => {
            firstlbl = false;
            let bwrw = res.bw.rows.filter(x => x.b_Art == row.Bezeichnung);
            if (bwrw.length > 0) {
              if (cntRnge < row.DiaWert) cntRnge = row.DiaWert;
              bwrw.forEach(rw => {
                let newPlot: Plotly.Data = {
                  name: row.Bezeichnung,
                  visible: true,
                  type: 'scatter',
                  line: {
                    width: 3,
                    color: '#' + row.intColDia.toString(16).padStart(6, '0'),
                  },
                  x: [rw.b_StartMeter, rw.b_EndMeter],
                  y: [row.DiaWert, row.DiaWert],
                  showlegend: !firstlbl,
                  hovertext: row.Bezeichnung + ' ' + (rw.b_Bezeichnung ?? ''),
                  hoverlabel: { namelength: -1 },
                };
                firstlbl = true;
                this.graph.data[0].yData.push(newPlot);
              });
            }
          });
          this.graph.data[0].layout.yaxis.range[1] = cntRnge + 1;
        });
    } else if (this.graph.data[0].name == 'Bauwerke') this.graph.data.splice(0, 1);
  }
  getFeatPos(pos: string) {
    let coordPoint = this.highlightfeature
      .getGeometry()
      .getCoordinateAt(parseFloat(pos) / geoDesLength(this.highlightfeature.getGeometry()));
    this.geolayer.setStyle(this.getLayerStyles());

    this.positionFeature.setGeometry(new Point(coordPoint));
    this.positionFeature.setStyle(
      new OlStyle({
        image: new CircleStyle({
          radius: 6,
          fill: new Fill({
            color: 'green',
          }),
          stroke: new OlStroke({
            color: 'green',
            width: 2,
          }),
        }),
        zIndex: 3,
      })
    );
  }
  getLayerStyles() {
    return (feature, resolution) => {
      let prop = feature.getProperties();
      if (prop.geometry.getType() == 'LineString' || prop.geometry.getType() == 'MultiLineString') {
        if (
          JSON.stringify(feature.getGeometry().getCoordinates()) ===
          JSON.stringify(this.highlightfeature.getGeometry().getCoordinates())
        ) {
          return new OlStyle({
            stroke: new OlStroke({
              color: 'red',
              width: 4,
            }),
            zIndex: 2,
          });
        } else {
          return new OlStyle({
            stroke: new OlStroke({
              color: this.darkMap ? 'grey' : 'black',
              width: 4,
            }),
            zIndex: 1,
          });
        }
      }
    };
  }

  closeModal() {
    this.isDetailViewVisible = false;
    if (this.curGraph.yData[this.curGraph.yData.length - 1].name == 'Selektierte Position') {
      this.curGraph.yData[this.curGraph.yData.length - 1] = undefined;
    }
  }
}
